import { coreApi } from 'src/api/config';

const fetchVisibilityRules = async (personId) => {
  const response = await coreApi.query(`people/${personId}/visibility_rules`);
  return response?.data;
};

export default fetchVisibilityRules;
